import { inject as service } from '@ember/service';
import ItemsV3Serializer from '@square/dashboard-items-data/serializers/items-v3-base';
export default ItemsV3Serializer.extend({
  intl: service(),
  userInfo: service(),
  attrs: {
    hasSelectedAllItems: {
      serialize: false
    }
  },
  normalize(typeClass, hash) {
    if (hash && !hash.fee_type_name) {
      const feeType = this.userInfo.countryFeatures.feeTypes.findBy('value', hash.fee_type_id);
      if (feeType) {
        let translatedFeeType;
        switch (feeType.labelKey) {
          case 'GST':
            translatedFeeType = this.intl.t('feeTypes.GST');
            break;
          case 'HST':
            translatedFeeType = this.intl.t('feeTypes.HST');
            break;
          case 'PST':
            translatedFeeType = this.intl.t('feeTypes.PST');
            break;
          case 'QST':
            translatedFeeType = this.intl.t('feeTypes.QST');
            break;
          case 'defaultSalesTax':
            translatedFeeType = this.intl.t('feeTypes.defaultSalesTax');
            break;
          case 'jpSalesTax':
            translatedFeeType = this.intl.t('feeTypes.jpSalesTax');
            break;
          case 'usSalesTax':
            translatedFeeType = this.intl.t('feeTypes.usSalesTax');
            break;
          default:
            translatedFeeType = '';
        }
        hash.fee_type_name = translatedFeeType;
      }
    }
    return this._super(typeClass, hash);
  }
});